import React from 'react';
import PropTypes from 'prop-types';
import {List, Subheader, Divider, Paper} from 'material-ui';
import Error from "../common/Error/Error";
import NewsItem from './NewsItem';
import style from '../../styles/styles';

const NewsList = (props) => {
    const { news, title, user, app, currentLang } = props;

    let content;

    if (news.length === 0) {
        content =
            <Error
                title="No data"
                subtitle="Add some news"
            />
    }  else {
        content = news[currentLang].map(function(oneNews, index) {
            return <div key={oneNews.id}>
                <NewsItem
                    app={app}
                    user={user}
                    news={oneNews}
                />
                {index !== (news.length - 1) &&  <Divider inset={true}/>}
            </div>
        })
    }

    return (
        <Paper>
            <List>
                <Subheader style={style.subHeader}>{title}</Subheader>
                {content}
            </List>
        </Paper>
    );
};

NewsList.propTypes = {
    news: PropTypes.object.isRequired,
    user: PropTypes.object.isRequired,
    app: PropTypes.object.isRequired,
    title: PropTypes.string,
    currentLang: PropTypes.string
};

export default NewsList;



// WEBPACK FOOTER //
// src/components/news/NewsList.js